import {
  MaterialUICore,
  axiomTokens,
  Dialog,
  Button,
} from '@iclinic/design-system';
import { DialogProps } from '@iclinic/design-system/src/components/Dialog';

const { styled } = MaterialUICore;

type DialogType = {
  theme: MaterialUICore.Theme;
  positionTop: string;
  positionLeft: string;
} & DialogProps;

export const ButtonStyled = styled(Button)(() => ({
  '&.MuiButton-outlined': {
    minWidth: '0px',
    padding: '0px',
    width: '32px',
    height: '32px',
    border: '1px solid #0000001A',
    color: '#00000099',

    '&:hover': {
      border: '1px solid #0000001A',
      color: '#00000099',
    },
  },
}));

export const StyledDialog = styled(Dialog)(
  ({ positionTop, positionLeft }: DialogType) => ({
    pointerEvents: 'none',
    position: 'relative',

    '& .MuiDialog-container': {
      pointerEvents: 'none',
    },

    '& .MuiDialog-paper': {
      position: 'fixed',
      top: positionTop,
      left: positionLeft,
      margin: 0,
      overflow: 'visible',
    },

    '& .MuiDialog-paperWidthSm': {
      maxWidth: '800px',
    },
    '& .MuiDialog-paper::before': {
      content: '""',
      position: 'absolute',
      left: '-25px',
      top: '20px',
      width: '0',
      height: '0',
      borderLeft: '15px solid transparent',
      borderRight: '15px solid transparent',
      borderTop: `25px solid ${axiomTokens.color.background[1]}`,
      zIndex: 0,
      filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.2))',
      transform: 'rotate(90deg)',
    },

    '& .MuiDialog-paper::after': {
      content: '""',
      position: 'absolute',
      left: '-24px',
      top: '19px',
      width: '0',
      height: '0',
      borderLeft: '14px solid transparent',
      borderRight: '14px solid transparent',
      borderTop: `24px solid ${axiomTokens.color.background[1]}`,
      transform: 'rotate(90deg)',
      zIndex: 1,
    },

    '& .MuiPaper-root': {
      pointerEvents: 'all',
    },
  }),
);

export const DialogContent = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: axiomTokens.spacing[4],
  padding: axiomTokens.spacing[4],
});

export const TextContent = styled('div')({
  maxWidth: '375px',
  gap: axiomTokens.spacing[3],
  display: 'flex',
  flexDirection: 'column',
  marginTop: '10.43px',
});

export const Title = styled('h1')(() => ({
  color: axiomTokens.color.typeface.pure,
  font: axiomTokens.font.family.base,
  fontWeight: axiomTokens.font.weight.bold,
  fontSize: axiomTokens.font.size.md,
  margin: '0px',
}));

export const Description = styled('p')(() => ({
  color: axiomTokens.color.typeface.pure,
  font: axiomTokens.font.family.base,
  fontWeight: axiomTokens.font.weight.regular,
  fontSize: axiomTokens.font.size.xs,
}));

export const ActionArea = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: axiomTokens.spacing[6],
  marginTop: axiomTokens.spacing[1],
}));

export const ButtonClose = styled(Button)(() => ({
  '&.MuiButton-contained': {
    border: 'none',
    color: '#000000BD',
    backgroundColor: 'transparent',

    '&:hover': {
      background: axiomTokens.color.surface.subtle.hovered,
      color: axiomTokens.color.typeface.pure,
    },
  },
}));

export const ImageWrapper = styled('div')({
  width: '100%',
  maxWidth: '377px',
});
